import { render, staticRenderFns } from "./ResultDetailOutputOutLeft.vue?vue&type=template&id=71f3c5a2&scoped=true&"
import script from "./ResultDetailOutputOutLeft.vue?vue&type=script&lang=js&"
export * from "./ResultDetailOutputOutLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3c5a2",
  null
  
)

export default component.exports